export default {
  async loadMessages(locale) {
    return import('../i18n/' + locale + '.json');
  }
};
